import React from 'react';
import { makeStyles } from "@material-ui/core/styles";
import Grid from '@material-ui/core/Grid';
import { Link as Linker } from "react-router-dom";
import { Mobile, NotMobile } from '../../utils';

const Link = (props) => 
    <Linker {...props} style={{ textDecoration: "none", color: "inherit" }} />

const styles = makeStyles((theme) => ({
    container: {
      backgroundColor: "#3c9fe6",
      width: "100%",
      padding: "10px 0",
      height: "27px",
      display: "flex",
      justifyContent: "flex-end"
    },
    bodyContainer: {
        maxWidth: "1240px",
        margin: "auto",
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "flex-end",
        color: "#bdbdbd"
    },
    linksContainer: {
        display: "flex",
    },
    link: {
        fontFamily: "Lato",
        margin: "0 20px",
        cursor: "pointer",
        display: "flex",
        alignItems: "center",
        color: "#fff",
        "&:hover": {
            color: "black"
        }
    },
    socialLink: {
        margin: "0 11px -5px"
    },
    socialIcon: {
        width: "30px",
        cursor: "pointer"
    },
    mobileContainer: {
        display: "flex",
        flexDirection: "column"
    },
    tagLine: {
        color: "#fff",
        fontFamily: "Lato"
    },
    notMobileContainer: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        maxWidth: 1240,
        margin: "auto",
        width: "100%",
        alignItems: "center"
    },
    rightItems: {
        display: "flex",
        flexDirection: "row"
    },
    sub_link: {
        textDecoration: "none",
        color: "#fff",
        "&:visited": {
            color: "#fff"
        }
    },
    "@media (max-width: 767px)": {
        tagLine: {
            margin: "auto"
        },
        linksContainer: {
            display: "flex",
            flexDirection: "row",
            margin: "auto",
            justifyContent: "space-around",
            width: "100%"
        },
        link: {
            borderBottom: "1px solid #fff",
            cursor: "pointer"
        },
        socialContainer: {
            display: "flex",
            flexDirection: "row",
            marginLeft: "auto",
            marginTop: "20px"
        },
        linksContainer: {
            position: "relative",
            bottom: "-2px",
            justifyContent: "space-around"
        }
    }
}));

export default function TopFlair() {
    const classes = styles();

    const Links = () => {
        return (
            <>
                <Grid item className={classes.link}>
                    <a href={`https://lifeshack.us19.list-manage.com/subscribe/post?u=86fec8b983f1df74a98cb2fba&id=3c566d394b`} target="_blank" className={classes.sub_link}>
                        Subscribe
                    </a>
                </Grid>
                <Grid item className={classes.link}><Link to="/blog">Blog</Link></Grid> 
            </>
        )
    }

    return (
        <div className={classes.container}>
            <Mobile>
                <div className={classes.mobileContainer}>
                    <div className={classes.linksContainer}>
                        <Links />
                    </div>
                </div>
            </Mobile>
            <NotMobile>
                <div className={classes.notMobileContainer}>
                    <div className={classes.tagLine}>Keep up with the latest in Remote Work</div>
                    <div className={classes.rightItems}>
                        <Links />
                    </div>
                </div>
            </NotMobile>
        </div>
    )     
}
